// extracted by mini-css-extract-plugin
export default {"icon":"TrashIcon_icon__8rVBc"};